<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h3>Push Notification</h3>

      <div style="margin-bottom: 16px;">
        Push notification support is enabled for this application, so that users can receive messaging or voice call notifications when the app is in the background.
      </div>

      <div style="color: #ff0000;">
        <span style="font-style: italic;">
          Note: Due to some custom implementation on some chinese phone manufacturers, certain phone brands and models may not receive the FCM push notification once the app is killed/swiped away.
        </span>
      </div>
    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'demo',
    components: {
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>